var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{attrs:{"type":"primary","loading":_vm.isInserting},on:{"click":_vm.insertOXml}},[_vm._v(" insert content ")])}
var staticRenderFns = []

export { render, staticRenderFns }